/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Schema } from '../../../core/models/common/Schema';
import { OasParameter } from '../../models/OasParameter';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends OasParameter
 * @author eric.wittmann@gmail.com
 */
export class Oas20Parameter extends OasParameter {
    public type : string;

    public format : string;

    public items : Oas20Items;

    public collectionFormat : string;

    public default_ : any;

    public maximum : number;

    public exclusiveMaximum : boolean;

    public minimum : number;

    public exclusiveMinimum : boolean;

    public maxLength : number;

    public minLength : number;

    public pattern : string;

    public maxItems : number;

    public minItems : number;

    public uniqueItems : boolean;

    public enum_ : Array<string>;

    public multipleOf : number;

    public constructor(name? : any) {
        if(((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(name);
            if(this.type===undefined) this.type = null;
            if(this.format===undefined) this.format = null;
            if(this.items===undefined) this.items = null;
            if(this.collectionFormat===undefined) this.collectionFormat = null;
            if(this.default_===undefined) this.default_ = null;
            if(this.maximum===undefined) this.maximum = null;
            if(this.exclusiveMaximum===undefined) this.exclusiveMaximum = null;
            if(this.minimum===undefined) this.minimum = null;
            if(this.exclusiveMinimum===undefined) this.exclusiveMinimum = null;
            if(this.maxLength===undefined) this.maxLength = null;
            if(this.minLength===undefined) this.minLength = null;
            if(this.pattern===undefined) this.pattern = null;
            if(this.maxItems===undefined) this.maxItems = null;
            if(this.minItems===undefined) this.minItems = null;
            if(this.uniqueItems===undefined) this.uniqueItems = null;
            if(this.enum_===undefined) this.enum_ = null;
            if(this.multipleOf===undefined) this.multipleOf = null;
            if(this.type===undefined) this.type = null;
            if(this.format===undefined) this.format = null;
            if(this.items===undefined) this.items = null;
            if(this.collectionFormat===undefined) this.collectionFormat = null;
            if(this.default_===undefined) this.default_ = null;
            if(this.maximum===undefined) this.maximum = null;
            if(this.exclusiveMaximum===undefined) this.exclusiveMaximum = null;
            if(this.minimum===undefined) this.minimum = null;
            if(this.exclusiveMinimum===undefined) this.exclusiveMinimum = null;
            if(this.maxLength===undefined) this.maxLength = null;
            if(this.minLength===undefined) this.minLength = null;
            if(this.pattern===undefined) this.pattern = null;
            if(this.maxItems===undefined) this.maxItems = null;
            if(this.minItems===undefined) this.minItems = null;
            if(this.uniqueItems===undefined) this.uniqueItems = null;
            if(this.enum_===undefined) this.enum_ = null;
            if(this.multipleOf===undefined) this.multipleOf = null;
        } else if(name === undefined) {
            let __args = arguments;
            super();
            if(this.type===undefined) this.type = null;
            if(this.format===undefined) this.format = null;
            if(this.items===undefined) this.items = null;
            if(this.collectionFormat===undefined) this.collectionFormat = null;
            if(this.default_===undefined) this.default_ = null;
            if(this.maximum===undefined) this.maximum = null;
            if(this.exclusiveMaximum===undefined) this.exclusiveMaximum = null;
            if(this.minimum===undefined) this.minimum = null;
            if(this.exclusiveMinimum===undefined) this.exclusiveMinimum = null;
            if(this.maxLength===undefined) this.maxLength = null;
            if(this.minLength===undefined) this.minLength = null;
            if(this.pattern===undefined) this.pattern = null;
            if(this.maxItems===undefined) this.maxItems = null;
            if(this.minItems===undefined) this.minItems = null;
            if(this.uniqueItems===undefined) this.uniqueItems = null;
            if(this.enum_===undefined) this.enum_ = null;
            if(this.multipleOf===undefined) this.multipleOf = null;
            if(this.type===undefined) this.type = null;
            if(this.format===undefined) this.format = null;
            if(this.items===undefined) this.items = null;
            if(this.collectionFormat===undefined) this.collectionFormat = null;
            if(this.default_===undefined) this.default_ = null;
            if(this.maximum===undefined) this.maximum = null;
            if(this.exclusiveMaximum===undefined) this.exclusiveMaximum = null;
            if(this.minimum===undefined) this.minimum = null;
            if(this.exclusiveMinimum===undefined) this.exclusiveMinimum = null;
            if(this.maxLength===undefined) this.maxLength = null;
            if(this.minLength===undefined) this.minLength = null;
            if(this.pattern===undefined) this.pattern = null;
            if(this.maxItems===undefined) this.maxItems = null;
            if(this.minItems===undefined) this.minItems = null;
            if(this.uniqueItems===undefined) this.uniqueItems = null;
            if(this.enum_===undefined) this.enum_ = null;
            if(this.multipleOf===undefined) this.multipleOf = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Parameter#createSchema()
     * @return {Schema}
     */
    public createSchema() : Schema {
        let rval : Schema = new Oas20Schema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates an Items.
     * @return {Oas20Items}
     */
    public createItems() : Oas20Items {
        let rval : Oas20Items = new Oas20Items();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }
}
Oas20Parameter["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Parameter";
Oas20Parameter["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];





import { Oas20Schema } from './Oas20Schema';


import { Oas20Items } from './Oas20Items';

